import "../CSS/tantramassage.css";

import TantramassageNavigation
    from "../components/TantramassageNavigation";


function TantramassagePage() {

    return (
        <>

            <TantramassageNavigation />

            <div className="intro">
                <h1>
                    Tantramassage im Sarganserland
                </h1>
            </div>

            <main className="tantramassage-main">

                <section className="tantramassage-text">

                    <p>
                        Bei IRJ-Tantramassagen biete ich achtsame
                        Tantramassagen im Sarganserland an.
                        Mein Angebot richtet sich an Menschen aus
                        Mels, Sargans, Bad Ragaz und der Umgebung,
                        die sich bewusst Zeit für Entspannung,
                        Berührung und Körperwahrnehmung nehmen möchten.
                    </p>

                    <h2>
                        Was ist eine Tantramassage?
                    </h2>

                    <p>
                        Eine Tantramassage ist eine körperorientierte Massageform,
                        die Elemente aus moderner Körperarbeit, Achtsamkeit und
                        tantrisch inspirierten Ansätzen verbindet. Im Mittelpunkt
                        stehen Entspannung, bewusstes Spüren, Atmung und die
                        Wahrnehmung des gesamten Körpers.
                    </p>

                    <p>
                        Sie unterscheidet sich damit deutlich von einer klassischen
                        medizinischen oder Wellnessmassage.
                    </p>

                    <h2>
                        Wie läuft eine Tantramassage typischerweise ab?
                    </h2>

                    <p>
                        Am Anfang führen wir ein Vorgespräch. Dabei werden Ablauf,
                        Wünsche, persönliche Grenzen und Tabuzonen besprochen.
                    </p>

                    <p>
                        Bei einer professionellen Tantramassage ist das Thema
                        Einvernehmlichkeit und Grenzen ein wesentlicher Bestandteil.
                    </p>

                    <p>
                        Danach kannst Du Dich duschen und dann bekommst Du von mir
                        ein Lungi zum Anziehen.
                    </p>

                    <p>
                        Wir beginnen gemeinsam das Tantra-Ritual mit einer
                        Begrüssung und einer kleinen Zeremonie.
                    </p>

                    <p>
                        Nach der Zeremonie lade ich Dich ein, es Dir auf dem Futon
                        bequem zu machen, damit wir mit der Massage beginnen können.
                    </p>

                    <p>
                        Die Massage selbst wird langsam und achtsam ausgeführt.
                    </p>

                    <p>
                        Ich gebe Dir Zeit, Dich selber zu spüren, zu entspannen und
                        die Berührungen zu empfangen.
                    </p>

                    <p>
                        Jede Massage ist einzigartig und ich gehe auf Dich ein und
                        frage nach, wenn etwas nicht stimmig sein sollte.
                    </p>

                    <p>
                        Nach der Massage gebe ich Dir Zeit zum Nachruhen, Duschen
                        wenn gewünscht und wir treffen uns wieder bekleidet zu
                        einem Nachgespräch.
                    </p>

                    <p>
                        Ein wesentlicher Unterschied zu vielen klassischen Massagen
                        ist, dass die Tantramassage den Menschen als
                        Ganzkörpererfahrung betrachtet.
                    </p>

                    <p>
                        Normalerweise wird der Intimbereich miteinbezogen, sofern
                        dies vereinbart und gewünscht ist.
                    </p>

                    <p>
                        Das ist jedoch kein zwingender Bestandteil einer
                        Tantramassage.
                    </p>

                    <h2>
                        Was ist das Ziel?
                    </h2>

                    <p>
                        Das Ziel ist normalerweise nicht das klassische
                        „Durchkneten“ verspannter Muskeln.
                    </p>

                    <p>
                        Vielmehr geht es um Entspannung, Körperbewusstsein,
                        Loslassen und intensiveres Wahrnehmen von Berührung.
                    </p>

                    <p>
                        Manche Menschen erleben sie eher meditativ, andere
                        sinnlich oder emotional.
                    </p>

                </section>

            </main>

        </>
    );
}


export default TantramassagePage;